import { AbsoluteFill, useCurrentFrame, useVideoConfig, random } from "remotion";
import React from "react";

// VFX: Circular Frequency Spectrum
// Category: overlays · Tags: spectrum, circular, radial, music, frequency
export default function AudioSpectrumCircularLoop() {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();
  const cx = width / 2;
  const cy = height / 2;
  const bars = 64;
  const innerRadius = 180;
  const maxBarLength = 180;

  return (
    <AbsoluteFill style={{ background: "radial-gradient(circle at center, #1e293b 0%, #0a0e1a 100%)" }}>
      <svg width={width} height={height}>
        <defs>
          <linearGradient id="specGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#06b6d4" />
            <stop offset="50%" stopColor="#a855f7" />
            <stop offset="100%" stopColor="#ec4899" />
          </linearGradient>
        </defs>
        {Array.from({ length: bars }).map((_, i) => {
          const angle = (i / bars) * Math.PI * 2 - Math.PI / 2;
          // Pseudo-spectrum: lower freqs higher, modulated by time
          const base = 0.3 + 0.7 * Math.pow(1 - i / bars, 1.2);
          const wobble = (Math.sin(frame * 0.18 + i * 0.4) + 1) * 0.5;
          const noise = random(`s-${i}-${Math.floor(frame / 3)}`);
          const amp = base * (0.5 + 0.5 * wobble) * (0.7 + 0.3 * noise);
          const barLength = innerRadius + amp * maxBarLength;
          const x1 = cx + Math.cos(angle) * innerRadius;
          const y1 = cy + Math.sin(angle) * innerRadius;
          const x2 = cx + Math.cos(angle) * barLength;
          const y2 = cy + Math.sin(angle) * barLength;
          return (
            <line key={i} x1={x1} y1={y1} x2={x2} y2={y2}
              stroke="url(#specGrad)" strokeWidth={6} strokeLinecap="round"
              opacity={0.85} />
          );
        })}
        <circle cx={cx} cy={cy} r={innerRadius - 8} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={2} />
      </svg>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
